import { Component } from '@angular/core';

import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [RouterLink],
  template: `
    <footer class="footer">
      <div class="footer-content">
        <div class="footer-section">
          <h4>О платформе</h4>
          <ul>
            <li><a routerLink="/about">О нас</a></li>
            <li><a routerLink="/approach">Наш подход</a></li>
            <li><a routerLink="/contacts">Контакты</a></li>
            <li><a routerLink="/terms">Условия использования</a></li>
            <li><a routerLink="/privacy">Политика конфиденциальности</a></li>
          </ul>
        </div>
        <div class="footer-section">
          <h4>Для клиентов</h4>
          <ul>
            <li><a routerLink="/catalog">Каталог</a></li>
            <li><a routerLink="/map-catalog">Карта</a></li>
            <li><a [routerLink]="['/catalog']" [queryParams]="{ favorites: 1 }">Избранное</a></li>
            <li><a routerLink="/subscriptions">Подписки</a></li>
          </ul>
        </div>
        <div class="footer-section">
          <h4>Для риелторов</h4>
          <ul>
            <li><a routerLink="/register">Регистрация</a></li>
            <li><a routerLink="/create-property">Добавить объявление</a></li>
          </ul>
        </div>
        <div class="footer-section">
          <h4>Контакты</h4>
          <ul>
            <li>Санкт-Петербург и ЛО</li>
            <li>Служба поддержки:</li>
            <li>info&#64;mkvm.ru</li>
          </ul>
        </div>
      </div>
      <div class="footer-bottom">
        <p>&copy; 2026 МКВМ. Все права защищены.</p>
      </div>
    </footer>
  `,
  styles: [`
    .footer {
      background: #2c3e50;
      color: #fff;
      padding: 3rem 1rem 1rem;
      margin-top: auto;
    }
    .footer-content {
      max-width: 1400px;
      margin: 0 auto;
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
      gap: 2rem;
    }
    .footer-section h4 {
      margin: 0 0 1rem;
      color: #fff;
      font-weight: 600;
    }
    .footer-section ul {
      list-style: none;
      padding: 0;
      margin: 0;
    }
    .footer-section li {
      margin-bottom: 0.5rem;
    }
    .footer-section a {
      color: #bbb;
      text-decoration: none;
      transition: color 0.2s;
    }
    .footer-section a:hover {
      color: #fff;
    }
    .footer-bottom {
      max-width: 1400px;
      margin: 2rem auto 0;
      padding-top: 1rem;
      border-top: 1px solid rgba(255,255,255,0.1);
      text-align: center;
      color: #888;
    }
  `]
})
export class FooterComponent {}
